"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTypeButton = void 0;
exports.SearchTag = SearchTag;
var React = require("react");
var FileIcon = require("components/FileIcon");
var Icon_1 = require("components/Icon");
require("./style.scss");
function SearchTag(props) {
    var ico = FileIcon.typeToIconAndTextMap(props.type);
    return (React.createElement("span", { className: "search-type-button" },
        React.createElement("span", { className: 'icon' }, ico.icon),
        React.createElement("span", { className: 'text' }, ico.text),
        React.createElement("span", { className: 'close' },
            React.createElement(Icon_1.Icon, { onClick: props.onClose, className: "fa-times-circle" }))));
}
var SearchTypeButton = function (props) {
    return props.searchOptions.searchFileType.fold(React.createElement("span", null), function (type) { return (React.createElement(SearchTag, { type: type, onClose: props.clearSearchFileTypeClicked })); });
};
exports.SearchTypeButton = SearchTypeButton;
